/** Resolve stored invoice file metadata from PaymentHistory API shapes. */
export function paymentFileInfo(file) {
    if (file == null || file === '') {
        return null;
    }

    // Rare: raw converter string "@@name;id"
    if (typeof file === 'string') {
        const raw = file.trim();
        if (!raw) return null;
        const parts = raw.split('@@').filter(Boolean);
        for (const part of parts) {
            const [name, id] = part.split(';');
            if (name && id) {
                return {name: name.replace(/^\$/, ''), id};
            }
        }
        return null;
    }

    if (typeof file !== 'object') {
        return null;
    }

    // FileDTO shape: { name, fileId } or { name, id }
    if (file.fileId || file.id) {
        return {
            name: file.name || 'فاکتور',
            id: file.fileId || file.id,
        };
    }

    // Nested: { file: { name, fileId } }
    if (file.file && typeof file.file === 'object') {
        const nested = paymentFileInfo(file.file);
        if (nested) return nested;
    }

    // Map shape from JPA converter: { "invoice.pdf": "uuid" }
    const keys = Object.keys(file);
    for (const name of keys) {
        const id = file[name];
        if (typeof id === 'string' && id.trim()) {
            return {name: name || 'فاکتور', id: id.trim()};
        }
        if (id && typeof id === 'object') {
            const nested = paymentFileInfo(id);
            if (nested) return nested;
        }
    }

    return null;
}
